import { Navigate, Outlet } from "react-router-dom";
import Layout from "./Layout";

export default function ProtectedLayout() {
  const token = localStorage.getItem("token");

  if (!token) return <Navigate to="/login" replace />;

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}